import {TourService} from 'ngx-tour-ngx-bootstrap';
import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {TourActiveService} from '../../Services/tour-active.service';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../Services/user.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {environment} from 'src/environments/environment';

declare var $: any;

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TourComponent implements OnInit, OnDestroy {
  toursSteps = [];
  globalTour = false;
  unsubscribe$: Subject<void> = new Subject<void>();
  stepId = 0;
  userData: any = {};
  public imgUrl: any = environment.imgUrl;

  constructor(public tourService: TourService,
              private tourActiveService: TourActiveService,
              private translate: TranslateService,
              private userService: UserService) {

    this.translate.get('tour.tour-steps').pipe(takeUntil(this.unsubscribe$)).subscribe(sections => this.toursSteps = sections);

    this.userData = this.userService.getLoggedData();
    

    this.tourActiveService.activateTourEvent.pipe(takeUntil(this.unsubscribe$)).subscribe(tuple => {

      this.showTour(tuple.tourSection);
    });

    this.userService.changeLanguageEvent2.pipe(takeUntil(this.unsubscribe$)).subscribe((lang) => {
      this.translate.setDefaultLang(lang.toLocaleLowerCase());
      setTimeout(() => {
        
        if (this.tourService.currentStep && this.tourService.currentStep.anchorId !== 'user-profile-tabs') {
          this.changeTourLanguage(this.tourService.currentStep.title, this.tourService.currentStep.stepId);
        }
      }, 500);
    });

    this.tourActiveService.endTourEvent.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.tourService.end());
  }

  showTour(sectionName: string) {
    
    this.tourService.steps = [];
    if (sectionName === 'global' && (this.userData.verificationStatusString !== "SUCCESS" || this.userData.verificationCount < 1)) {
      this.globalTour = true;
    } else {
      this.globalTour = false;
    }
    if (this.globalTour) {
      $('#welcome_tour').modal('show');
    } else {
      this.translate.get('tour.tour-steps').pipe(takeUntil(this.unsubscribe$)).subscribe(sectionSteps => {
        this.toursSteps = sectionSteps;
        this.loadTour(sectionName);
        this.tourService.start();
        this.reviewPrevNext();
      });
    }
  }

  startGlobalTour(start: boolean) {
    
    this.stepId = 0;
    this.translate.get('tour.tour-sections').pipe(takeUntil(this.unsubscribe$)).subscribe(sections => {
      const allSections = sections;
      for (const section of allSections) {
        this.translate.get('tour.tour-steps').pipe(takeUntil(this.unsubscribe$)).subscribe(sectionSteps => {
          this.toursSteps = sectionSteps;
          
          this.loadTour(section);
        });
      }
      if (start) {
        this.tourService.start();
        this.reviewPrevNext();
      }
    });
  }

  changeTourLanguage(sectionName: string, stepId: string) {
    this.tourService.steps = [];
    if (this.globalTour) {
      this.tourService.end();
      this.startGlobalTour(false);
      this.tourService.startAt(stepId);
      this.reviewPrevNext();
    } else {
      this.translate.get('tour.tour-steps').pipe(takeUntil(this.unsubscribe$)).subscribe(sections => {
        this.toursSteps = sections;
        
        this.loadTour(sectionName);
        this.tourService.end();
        this.tourService.startAt(stepId);
        this.reviewPrevNext();
      });
    }
  }

  loadTour(sectionName: string) {
    const sectionTourFilter = this.toursSteps.filter(value => value.sectionName === sectionName);
    if (sectionTourFilter !== undefined && sectionTourFilter.length === 1) {
      const sectionTour = sectionTourFilter[0];
      if (sectionTour.steps) {
        for (let stepIndex = 0; stepIndex < sectionTour.steps.length; stepIndex++) {
          this.stepId = this.globalTour ? this.stepId += 1 : stepIndex + 1;
          if (this.userData.verificationStatus) {
            this.tourService.initialize(this.tourService.steps.concat({
              stepId: this.stepId.toString(),
              anchorId: sectionTour.steps[stepIndex].anchorId,
              title: sectionTour.steps[stepIndex].title,
              content: sectionTour.steps[stepIndex].content,
              placement: sectionTour.steps[stepIndex].placement,
              route: sectionTour.steps[stepIndex].route
            }));
          }

          if (!this.userData.verificationStatus && sectionTour.steps[stepIndex].verified === 'true') {
            this.tourService.initialize(this.tourService.steps.concat({
              stepId: this.stepId.toString(),
              anchorId: sectionTour.steps[stepIndex].anchorId,
              title: sectionTour.steps[stepIndex].title,
              content: sectionTour.steps[stepIndex].content,
              placement: sectionTour.steps[stepIndex].placement,
              route: sectionTour.steps[stepIndex].route
            }));
          }
        }
      }
    }
  }

  ngOnInit(): void {
   
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  reviewPrevNext() {
    if (this.tourService.steps.length) {
      if (this.tourService.currentStep) {
        if (this.tourService.steps[Number(this.tourService.currentStep.stepId) + 1]) {

          this.tourActiveService.openTab(this.tourService.steps[Number(this.tourService.currentStep.stepId) + 1].route.toString());
        }
      } else {
        this.tourActiveService.openTab(this.tourService.steps[0].route.toString());
      }
    }
  }
}
